import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './shop-item.scss';

const ShopItem = (props) => (
    <a href="/flag" className="shopItem">
        <div className="imageWrap">
            <div
                className={cx(
                    {
                        imageA: props.imageUrl === 'a',
                        imageB: props.imageUrl === 'b',
                    },
                    'image'
                )}
            />
        </div>
        <div className="name">{props.name.toUpperCase()}</div>
        <div className="about">{props.about.toUpperCase()}</div>
        <div className="size">{props.size.toUpperCase()}</div>
        <div className="price">£{props.price}</div>
    </a>
);

ShopItem.propTypes = {
    imageUrl: PropTypes.string,
    name: PropTypes.string,
    about: PropTypes.string,
    size: PropTypes.string,
    price: PropTypes.number,
};

export default ShopItem;
